import React from 'react';
import { connect } from 'react-redux';

import OverlayFull from '../../components/overlayFull/overlayFull';
import Logo from '../../components/logo/logo';
import Title from '../../components/title/title';
import Price from '../../components/price/price';
import GallerySlider from '../../components/gallerySlider/gallerySlider';
import ErrorBoundary from '../../../ErrorBoundary';
import RatingSummary from '../../../reusable-components/Ratings/RatingSummary';
import './aboveFoldStyle.less';
// import BreadcrumbsNew from '../../components/breadcrumbs/BreadcrumbsNew';
// import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';

function AboveFold({ productID }) {
  return (
    <div id="aboveFold">
      <OverlayFull />
      <Logo />
      {/* <BreadcrumbsNew
          sidePadding
          breadcrumbs={window.__INITIAL_STATE__.breadcrumbs}
          position="top"
          expandable
        /> */}
      <ErrorBoundary location="productpage" errorComponent={null}>
        <GallerySlider />
      </ErrorBoundary>
      <div className="bv-rating-container">
        <RatingSummary productID={productID} />
      </div>
      <Title />
      <ErrorBoundary location="productpage" errorComponent={null}>
        <Price />
      </ErrorBoundary>
      <div className="spacer" />
    </div>
  );
}

const mapStateToProps = ({ app }) => {
  return {
    productID: app.data.product_id,
  };
};

export default connect(mapStateToProps)(AboveFold);
